<template>
  <div class="notes">
    <div class="note_list">
      <div style="padding: 0 15px">
        <template v-if="total > 0">
          <div class="one_note" v-for="item in noteList" :key="item.id">
            <div class="top_row">
              <p class="chapter_title">{{ item.chapterName }}</p>
              <div class="btns">
                <i class="el-icon-edit" @click="handleEdit(item)"></i>
                <i class="el-icon-delete" @click="handleDel(item.notesId)"></i>
              </div>
            </div>

            <p class="note_content">{{ item.note }}</p>
          </div>
        </template>
        <el-empty class="empty" v-else description="暂无笔记"></el-empty>
      </div>
    </div>
    <el-pagination
      small
      @current-change="pageChange"
      :current-page.sync="params.page"
      :page-size="params.limit"
      layout="prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <div style="padding: 10px 15px; height: 180px">
      <el-input
        type="textarea"
        :rows="4"
        resize="none"
        placeholder="请输入内容"
        v-model="noteContent"
        ref="input"
      >
      </el-input>
      <el-button class="save_btn" type="primary" @click="handleSave">{{
        isEdit ? "修改" : "保存"
      }}</el-button>
      <el-button
        class="cancel_btn"
        type="primary"
        @click="
          isEdit = false;
          noteContent = '';
        "
        v-show="isEdit"
        >取消</el-button
      >
    </div>
  </div>
</template>

<script>
import { noteList, addNote, editNote, delNote } from "@/api/note";
export default {
  name: "notes",
  data() {
    return {
      params: {
        classChapterId: this.$route.query.classChapterId,
        page: 1,
        limit: 6,
        query: "",
      },
      total: 10,
      noteList: [],
      noteContent: "",
      notesId: null,
      isEdit: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 笔记列表
    getList() {
      this.$loading.show();
      noteList(this.params).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.noteList = res.data.records;
          this.total = res.data.total;
        } else {
          console.log(res.msg);
        }
      });
    },
    // 新增(编辑)笔记
    handleSave() {
      if (!this.noteContent) {
        this.$message.warning("请输入笔记内容");
        return;
      }
      if (this.isEdit) {
        this.$loading.show();
        editNote({
          notesId: this.notesId,
          note: this.noteContent,
          classChapterId: this.$route.query.classChapterId
        }).then((res) => {
          this.$loading.hide();
          if (res.code == 0) {
            this.getList();
            this.$message.success("编辑成功");
          } else {
            this.$message.error(res.msg);
          }
          this.noteContent = "";
          this.isEdit = false;
        });
      } else {
        this.$loading.show();
        addNote({
          classChapterId: this.$route.query.classChapterId,
          note: this.noteContent,
        }).then((res) => {
          this.$loading.hide();
          if (res.code == 0) {
            this.getList();
            this.$message.success("新增成功");
            this.noteContent = "";
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    handleEdit(note) {
      this.$refs.input.focus();
      this.isEdit = true;
      this.notesId = note.notesId;
      this.noteContent = note.note;
    },
    // 删除笔记
    handleDel(notesId) {
      this.$confirm("确定要删除这条笔记吗?", {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          delNote(notesId).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.getList();
              this.$message.success("删除成功");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    pageChange() {
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.notes {
  // padding: 15px;
  height: 100%;
  .note_list {
    position: relative;
    margin-bottom: 10px;
    height: calc(100% - 180px - 21px - 15px);
    overflow: auto;

    .empty {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    &::-webkit-scrollbar {
      width: 4px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      background-color: #c8c8c8;
    }

    .one_note {
      padding: 8px 10px 10px;
      border-bottom: solid 1px #646464;

      .top_row {
        // margin-bottom: 10px;

        .chapter_title {
          display: inline-block;
          width: 80%;
          font-size: 15px;
          color: #969696;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .btns {
          float: right;
          i {
            margin-left: 10px;
            font-size: 16px;
            cursor: pointer;
            color: #409eff;
            &.el-icon-delete {
              color: #f56c6c;
            }
          }
        }
      }
      .note_content {
        text-indent: 2em;
        font-size: 14px;
        color: #ffffff;
        text-align: justify;
      }
    }
  }
  ::v-deep .el-pagination {
    margin-right: 15px;
    text-align: right;
    .btn-prev,
    .btn-next {
      color: #fff;
      background-color: inherit;
      &:hover {
        color: #409eff;
      }
      &:disabled {
        color: #c0c4cc;
      }
    }
    .el-pager {
      .number {
        color: #fff;
        background-color: inherit;
        &.active,
        &:hover {
          color: #409eff;
        }
      }
    }
    .el-pagination__jump {
      color: #fff;
    }
  }

  ::v-deep .el-textarea__inner {
    font-family: inherit;
  }

  .save_btn,
  .cancel_btn {
    float: right;
    margin-top: 10px;
    width: 100px;
    border-color: #1890ff;
    background: #1890ff;
    border-radius: 4px;
    &.cancel_btn {
      margin-right: 15px;
    }
  }
}
</style>